<template>
  <div>
    <el-card>
      <div class="forms">
        <el-form :inline="true" :model="form" class="demo-form-inline">
          <el-form-item label="服务类型">
            <!-- <el-input v-model="form.videoTitle"></el-input> -->
            <el-select v-model="form.type" clearable filterable>
              <el-option
                v-for="item in option"
                :label="item.label"
                :value="item.value"
                :key="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="订单号">
            <el-input v-model="form.orderNr"></el-input>
          </el-form-item>
          <el-form-item label="电话">
            <el-input v-model="form.phone"></el-input>
          </el-form-item>
          <el-form-item label="名字">
            <el-input v-model="form.name"></el-input>
          </el-form-item> -->
          <el-form-item>
            <el-button class="btnBackgory" @click="searchData">搜索</el-button>
          </el-form-item>
          <el-form-item>
            <el-button class="btnBackgory" @click="addHomeData('dialogForm')"
              >新增服务</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-popconfirm
              title="您确定要删除多条数据吗？"
              @confirm="deleteData"
            >
              <el-button class="btnBackgory" slot="reference"
                >批量删除</el-button
              >
            </el-popconfirm>
          </el-form-item>
        </el-form>

        <el-table
          ref="table"
          v-loading="loading"
          :data="tableData"
          border
          tooltip-effect="dark"
          style="width: 100%; margin-top: 20px"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55" align="center" />
          <el-table-column
            prop="typeStr"
            label="服务类型"
            min-width="100"
            align="center"
          />
          <el-table-column
            prop="orderNr"
            label="订单号"
            min-width="80"
            align="center"
          />
          <el-table-column
            prop="phone"
            label="电话号码"
            min-width="120"
            align="center"
          />
          <el-table-column
            prop="name"
            label="姓名"
            min-width="120"
            align="center"
          />
          <el-table-column
            prop="address"
            label="地址"
            min-width="120"
            align="center"
          />
          <el-table-column
            prop="repairQty"
            label="保修数量"
            min-width="120"
            align="center"
          />
          <el-table-column
            prop="failure"
            label="故障现象"
            min-width="120"
            align="center"
          />
          <el-table-column
            prop="doorTime"
            label="维修时间"
            min-width="140"
            align="center"
          />
          <el-table-column
            prop="installDate"
            label="安装时间"
            min-width="140"
            align="center"
          />
          <el-table-column prop="productNr" label="产品编号" align="center" />
          <el-table-column prop="remark" label="需求备注" align="center">
            <template #default="scope">
              <div v-if="scope.row.type === 1">
                <div>{{ scope.row.remark }}</div>
              </div>
              <div v-else>
                <template v-if="scope.row.imgs">
                  <div v-for="(item, ind) in scope.row.imgs" :key="ind">
                    <el-image
                      style="width: 50px; height: 50px"
                      :src="uploadUrl + item"
                      :preview-src-list="[uploadUrl + item]"
                    >
                    </el-image>
                  </div>
                </template>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="100" align="center">
            <template #default="scope">
              <div class="operate">
                <div class="btn" @click="edit(scope.row)">编辑</div>
                <el-popconfirm
                  title="您确认要删除该条数据吗？"
                  @confirm="deleteOnly(scope.row)"
                >
                  <div slot="reference" class="btn">删除</div>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pageContainer">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageData.page"
            :page-sizes="[20, 40, 60, 80, 100]"
            :page-size="pageData.pageSize"
            layout="total, prev, pager, next,sizes"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </el-card>

    <el-dialog
      :title="`${title}服务`"
      :visible.sync="dialogVisible"
      width="750px"
      @close="cancelBtn('dialogForm')"
    >
      <div class="forms">
        <el-form
          :model="dialogForm"
          :rules="dialogRules"
          ref="dialogForm"
          label-width="160px"
          class="demo-dialogForm"
          label-position="left"
        >
          <el-form-item label="服务类型" prop="type">
            <!-- @change="categorySelect" -->
            <el-select v-model="dialogForm.type" clearable>
              <el-option
                v-for="item in option"
                :label="item.label"
                :value="item.value"
                :key="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订单号" prop="orderNr">
            <el-input v-model="dialogForm.orderNr"></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="phone">
            <el-input v-model="dialogForm.phone"></el-input>
          </el-form-item>
          <el-form-item label="姓名" prop="name">
            <el-input v-model="dialogForm.name"></el-input>
          </el-form-item>
          <el-form-item label="地址" prop="address">
            <el-input v-model="dialogForm.address"></el-input>
          </el-form-item>
          <el-form-item
            v-if="dialogForm.type === 1"
            label="安装时间"
            prop="installDate"
          >
            <!-- <el-input v-model="dialogForm.installDate"></el-input> -->
            <el-date-picker
              v-model="dialogForm.installDate"
              type="datetime"
              placeholder="选择日期"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item
            v-if="dialogForm.type === 10"
            label="保修数量"
            prop="repairQty"
          >
            <el-input v-model="dialogForm.repairQty" type="number"></el-input>
          </el-form-item>
          <el-form-item
            v-if="dialogForm.type === 10"
            label="故障现象"
            prop="failure"
          >
            <el-input v-model="dialogForm.failure"></el-input>
          </el-form-item>
          <el-form-item
            v-if="dialogForm.type === 10"
            label="上门时间"
            prop="doorTime"
          >
            <el-date-picker
              v-model="dialogForm.doorTime"
              type="datetime"
              placeholder="选择日期"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="产品编号" prop="productNr">
            <el-input v-model="dialogForm.productNr"></el-input>
          </el-form-item>
          <el-form-item
            v-if="dialogForm.type === 1"
            label="需求备注"
            prop="remark"
          >
            <el-input
              type="textarea"
              v-model="dialogForm.remark"
              placeholder="请输入备注内容"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="dialogForm.type === 10"
            label="需求备注"
            prop="imgs"
          >
            <el-upload
              :action="`${upload}/file/uploadNew`"
              :on-success="handleSuccess"
              :on-remove="handleDelete"
              :file-list="fileList"
              list-type="picture-card"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
          <div class="footerBtn">
            <el-button class="dialogWhite" @click="cancelBtn('dialogForm')"
              >取 消</el-button
            >
            <el-button
              class="dialogBtnBackgory"
              @click="submitForm('dialogForm')"
              >确 定</el-button
            >
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import apis from "@/apis/gzh.js";
export default {
  name: "install",
  data() {
    return {
      form: {
        type: 1,
        // orderNr:'',
        // name:'',
        // phone:''
        // videoTitle: "",
      },
      option: [
        { label: "安装", value: 1 },
        { label: "维修", value: 10 },
      ],
      id: "",
      ids: [],
      title: "新增",
      // selectListData: [],
      // productSelectListData: [],
      loading: false,
      pageData: {
        page: 1,
        pageSize: 20,
      },
      total: 0,
      tableData: [],
      dialogVisible: false,
      // uploadUrl: "",
      // upload: "",
      dialogForm: {
        type: 1,
        orderNr: "",
        phone: "",
        name: "",
        address: "",
        installDate: "",
        repairQty: "",
        failure: "",
        doorTime: "",
        productNr: "",
        remark: "",
        imgs: "",
      },
      // videoLoading: false,
      // videoLink: "",
      dialogRules: {
        type: [{ required: true, message: "请选择类型", trigger: "change" }],
        orderNr: [{ required: true, message: "请输入订单号", trigger: "blur" }],
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        address: [{ required: true, message: "请输入地址", trigger: "blur" }],
        installDate: [
          { required: true, message: "请选择时间", trigger: "blur" },
        ],
        repairQty: [
          { required: true, message: "请输入保修数量", trigger: "blur" },
        ],
        failure: [
          { required: true, message: "请输入故障现象", trigger: "blur" },
        ],
        doorTime: [{ required: true, message: "请选择时间", trigger: "blur" }],
        productNr: [
          { required: true, message: "请输入产品编号", trigger: "blur" },
        ],
      },
      fileList: [],
      uploadUrl: "",
      upload: "",
      // uploadPercentage: 0,
    };
  },
  mounted() {
    this.upload = apis.upload;
    this.uploadUrl = apis.uploadUrl;
    this.getTableList({ ...this.pageData, ...this.form });
  },
  methods: {
    // 获取表格数据
    getTableList(json) {
      this.loading = true;
      apis.installMaintenancePageList(json).then((res) => {
        if (res.code === 200) {
          this.tableData = res.data;
          this.total = res.total;
          this.loading = false;
          this.tableData.forEach((item) => {
            if (item.imgs) {
              item.imgs = item.imgs.split(",");
            }
          });
        }
      });
    },
    // 搜索
    searchData() {
      const json = {
        ...this.pageData,
        ...this.form,
      };
      this.getTableList(json);
    },
    handleSizeChange(val) {
      this.pageData.pageSize = val;
      this.getSearchList({ ...this.pageData, ...this.form });
    },
    // 当前页
    handleCurrentChange(val) {
      this.pageData.page = val;
      this.getSearchList({ ...this.pageData, ...this.form });
    },
    // 新增
    addHomeData() {
      this.fileList = [];
      this.dialogVisible = true;
      this.id = "";
      this.title = "新增";
      this.dialogForm = {
        type: 1,
        orderNr: "",
        phone: "",
        name: "",
        address: "",
        installDate: "",
        repairQty: "",
        failure: "",
        doorTime: "",
        productNr: "",
        remark: "",
        imgs: "",
      };
    },
    // 编辑
    edit(row) {
      this.fileList = [];
      this.dialogVisible = true;
      this.id = row.id;
      this.title = "编辑";
      if (row.imgs) {
        row.imgs.forEach((item) => {
          this.fileList.push({
            name: item,
            url: this.uploadUrl + item,
            id: item,
          });
        });
      }
      this.$nextTick(() => {
        this.dialogForm = JSON.parse(JSON.stringify(row));
      });
    },
    //dialog 取消按钮
    cancelBtn() {
      this.dialogVisible = false;
      // this.$refs[formName]?.resetFields();
    },
    // table 选中
    handleSelectionChange(val) {
      this.ids = val.map((item) => item.id);
    },
    // 确认 添加
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const json = {
            ...this.dialogForm,
          };
          if (this.id) {
            json.id = this.id;
          }
          let arr = [];
          this.fileList && this.fileList.forEach((item) => {
            arr.push(item.id);
          });
          json.imgs = arr.join(",");
          apis.installMaintenanceAddOrUpdate(json).then((res) => {
            if (res.code === 200) {
              this.getTableList({ ...this.pageData, ...this.form });
              this.dialogVisible = false;
              this.$message({
                message: `${this.title}成功`,
                type: "success",
              });
              // this.$refs[formName]?.resetFields();
            }
          });
        }
      });
    },
    // 删除一条
    deleteOnly(row) {
      apis.installMaintenanceDelete([row.id]).then((res) => {
        if (res.code === 200) {
          this.getTableList({ ...this.pageData, ...this.form });
          this.$message({
            message: "删除成功",
            type: "success",
          });
        }
      });
    },
    // 批量 删除
    deleteData() {
      if (this.ids.length) {
        apis.installMaintenanceDelete(this.ids).then((res) => {
          if (res.code === 200) {
            this.getTableList({ ...this.pageData, ...this.form });
            this.$message({
              message: "删除成功",
              type: "success",
            });
          }
        });
      }
    },
    // 上传
    handleSuccess(file) {
      this.fileList.push({
        name: file.data.name,
        url: this.uploadUrl + file.data.id,
        id: file.data.id,
      });
    },
    handleDelete(file) {
      const index = this.fileList.findIndex((item) => item.id === file.id);
      this.fileList.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-card {
  margin: 20px;
}
// // 1 解决 table 表头和内容错误
// ::v-deep .el-table {
//   th.gutter,
//   colgroup.gutter {
//     width: 0px !important;
//   }
// }
// // 2 关键css代码
// ::v-deep .el-table__header colgroup col[name="gutter"] {
//   display: table-cell !important;
// }
::v-deep .el-dialog__title {
  display: flex;
  align-items: center;
  font-size: 29px;
  &::before {
    content: "";
    display: inline-block;
    width: 6px;
    height: 29px;
    background-color: #008754;
    margin-right: 10px;
  }
}
.forms {
  .el-button--mini {
    margin-right: 20px;
  }
  .btnBackgory {
    width: 181px;
    height: 54px;
    background-color: #008754;
    color: white;
  }
  .white {
    width: 181px;
    height: 54px;
  }
  .backgoryWhite {
    width: 181px;
    height: 54px;
  }
  .btnBorderColor {
    width: 181px;
    height: 54px;
    color: #008754;
    border-color: #008754;
  }
  ::v-deep .el-form {
    .left {
      .el-input--mini .el-input__inner {
        width: 295px;
      }
    }
    .footerBtn {
      text-align: right;
      .dialogWhite {
        width: 145px;
        height: 54px;
      }
      .dialogBtnBackgory {
        width: 145px;
        height: 54px;
        background-color: #008754;
        color: white;
      }
    }
  }
  ::v-deep .el-upload {
    width: 178px;
    height: 178px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  ::v-deep .el-upload:hover {
    border-color: #409eff;
  }
  ::v-deep .el-upload--picture-card {
    line-height: 178px;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
}
.pageContainer {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}
.aHref {
  color: #5e92ff;
}
.operate {
  display: flex;
  justify-content: space-around;
  .btn {
    color: #729fff;
  }
}
::v-deep .el-dialog {
  .el-form {
    .el-input {
      width: 770px;
    }
    .el-textarea__inner {
      width: 770px;
    }
  }
}
::v-deep .el-progress-circle {
  width: 178px !important;
  height: 178px !important;
}
</style>
